import { render, staticRenderFns } from "./BaseDialog.vue?vue&type=template&id=9ef8fd40&"
import script from "./BaseDialog.vue?vue&type=script&lang=ts&"
export * from "./BaseDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDialog.vue?vue&type=style&index=0&id=9ef8fd40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports